/** Rótulos das "Ações específicas" de Perfis. A mesma ação pode ter nome diferente por entidade (ex.: "registrar" é pagamento em Pagamentos e aplicação em Aplicações). */
export const ROTULO_ESPECIFICA: Record<string, string> = {
  visualizar: 'Visualizar',
  enviar: 'Enviar',
  inativar: 'Inativar 🔒',
  transferir_entidade: 'Transferir entidade',
  importar: 'Importar (.xlsx)',
  registrar_resultado: 'Registrar resultado',
  corrigir_encerrada: 'Corrigir encerrada',
  concluir: 'Concluir',
  alterar_comissao: 'Alterar comissão',
  editar_ptax: 'Editar PTAX',
  confirmar_dados_bancarios: 'Confirmar dados bancários',
  vincular_oc: 'Vincular OC do Cliente',
  substituir_oc: 'Substituir OC do Cliente',
  gerar: 'Gerar',
  faturar: 'Faturar',
  estornar_faturamento: 'Estornar faturamento',
  cancelar: 'Cancelar',
  excluir: 'Excluir (enviar à Lixeira) 🔒',
  ver_lixeira: 'Ver na Lixeira',
  restaurar: 'Restaurar da Lixeira 🔒',
  ver_restrito: 'Ver documentos restritos 🔒',
  reabrir_correcao: 'Reabrir para correção 🔒',
  reabrir_comercial: 'Reabertura comercial 🔒',
  acompanhar_locacao: 'Acompanhar locação',
  // Financeiro (A1)
  lancar: 'Lançar',
  confirmar_documento: 'Confirmar documento',
  registrar: 'Registrar pagamento',
  estornar: 'Estornar 🔒',
  lancar_compra: 'Lançar compra no cartão',
  conferir_fatura: 'Conferir fatura',
  informar_credito_encargo: 'Informar crédito, estorno ou encargo',
  importar_extrato: 'Importar extrato',
  conciliar: 'Conciliar',
  desfazer: 'Desfazer conciliação 🔒',
  fechar: 'Fechar período',
  reabrir: 'Reabrir período 🔒',
  // Contas a Receber
  ajustar_condicao: 'Definir ou ajustar condição da comissão',
  redistribuir: 'Redistribuir estimativa',
  registrar_pagamento_cliente: 'Registrar pagamento do Cliente',
  estornar_pagamento_cliente: 'Estornar pagamento do Cliente 🔒',
  confirmar_valor: 'Confirmar valor da comissão',
  cancelar_comissao: 'Cancelar comissão 🔒',
  registrar_avulso: 'Registrar recebível avulso',
  cancelar_avulso: 'Cancelar recebível avulso 🔒',
  emitir_nota: 'Emitir ou reemitir nota da Inttrix',
  cancelar_nota: 'Cancelar nota da Inttrix 🔒',
  registrar_recebimento: 'Registrar recebimento',
  estornar_recebimento: 'Estornar recebimento 🔒',
  gerir_credito: 'Gerir crédito do pagador',
  completar_legado: 'Completar operações antigas (lote) 🔒',
  solicitar_resgate: 'Registrar solicitação de resgate',
};

/** Rótulo por entidade: vale antes do rótulo geral da ação. */
export const ROTULO_ESPECIFICA_POR_ENTIDADE: Record<string, Record<string, string>> = {
  aplicacao: {
    registrar: 'Registrar aplicação',
    corrigir: 'Corrigir aplicação',
    estornar: 'Estornar aplicação 🔒',
  },
  fluxo_caixa: {
    gerar_foto: 'Gerar foto da projeção',
  },
};

export function rotuloEspecifica(entidade: string, acao: string): string {
  return ROTULO_ESPECIFICA_POR_ENTIDADE[entidade]?.[acao] ?? ROTULO_ESPECIFICA[acao] ?? acao;
}
